import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { updateCompanyAsset } from "../../actions/newAsset";
import { getNewUnapprovedAsset } from "../../actions/newAsset";
import { Alert, IconButton, Tooltip } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import secureLocalStorage from "react-secure-storage";
import Typography from "@mui/material/Typography";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { deleteNewAsset } from "../../actions/newAsset";
import { Helmet } from "react-helmet-async";
import { message, Popconfirm } from "antd";
import toast from "react-hot-toast";

const columns = [
  { id: "code", label: "CODE", minWidth: 170, align: "center" },
  { id: "cost", label: "COST", minWidth: 170, align: "center" },
  {
    id: "depreciation_rate",
    label: "DEPN RATE",
    minWidth: 170,
    align: "center",
  },
  { id: "category", label: "Asset Pool", minWidth: 200, align: "center" },
  { id: "purchase_date", label: "PURCHASE DATE", minWidth: 200 },
  {
    id: "location",
    label: "LOCATION",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "description",
    label: "DESCRIPTION",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "supplier",
    label: "SUPPLIER",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "uploaded_by",
    label: "UPLOADED BY",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "intangible",
    label: "INTANGIBLE CAT.",
    minWidth: 170,
    align: "center",
    format: (value) => value.toFixed(2),
  },
];
export default function Approval() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [success, setSuccess] = React.useState("");

  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const newAsset = useSelector((state) => state.newAsset);
  const dispatch = useDispatch();
  async function handleApproveAsset(id) {
    if (!id) {
      toast.error("error approving asset");
      return;
    }
    try {
      setSuccess("approving asset");
      dispatch(
        updateCompanyAsset(id, {
          approved: "true",
          approved_by: user.results.firstName + " " + user.results.lastName,
        })
      );
      dispatch(getNewUnapprovedAsset());
      setSuccess("asset approved");
      setSuccess("");
    } catch (error) {
      toast.error(error.message);
      setSuccess("");
    }
  }
  async function handleDeleteAsset(id) {
    if (!id) {
      toast.error("Error deleting asset");
      return;
    }
    try {
      setSuccess("Deleting asset....");
      dispatch(deleteNewAsset(id));
      dispatch(getNewUnapprovedAsset());
      setSuccess("Asset approved");
      setSuccess("");
    } catch (error) {
      toast.error(error.message);
      setSuccess("");
    }
  }
  return (
    <div style={{ padding: "50px" }}>
      <Helmet title="Approvals | Assets Register" />
      <Typography
        variant="h6"
        style={{ color: `${mode === "dark" ? "#0883FF" : "#0000000"}` }}
      >
        {newAsset.length} Pending assets for approval
      </Typography>
      {success && <Alert severity="success">{success}</Alert>}
      <TableContainer
        sx={{ maxHeight: 540 }}
        style={{
          backgroundColor: `${mode === "dark" ? "#303030" : "#ffffff"}`,
          color: `${mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"}`,
        }}
      >
        <Table
          size="small"
          stickyHeader
          aria-label="sticky table"
          style={{
            backgroundColor: `${mode === "dark" ? "#303030" : "#ffffff"}`,
            color: `${mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"}`,
          }}
          sx={{
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,

              // bgcolor: "#cccc",
            },
          }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    top: 0,
                    minWidth: column.minWidth,
                    backgroundColor: "#3D4F58",
                    color: "white",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
              <TableCell style={{ backgroundColor: "#3D4F58", color: "white" }}>
                ACTIONS
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {newAsset?.map((data, index) => (
              <TableRow
                style={{
                  backgroundColor: `${mode === "dark" ? "#303030" : "#ffffff"}`,
                  color: `${
                    mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                  }`,
                }}
                hover
                role="checkbox"
                key={index}
                tabIndex={-1}
              >
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.code}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.cost}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.depreciation_rate + "%"}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.category}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {new Date(data.purchase_date).toLocaleDateString()}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.location}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.description}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.supplier}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.uploaded_by}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                  }}
                  align="center"
                >
                  {data.intangible}
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: `${
                      mode === "dark" ? "#303030" : "#ffffff"
                    }`,
                    color: `${
                      mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"
                    }`,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                  align="center"
                >
                  <Popconfirm
                    title="Do you want to proceed by approving this asset?"
                    okText="Yes"
                    onCancel={() => {
                      message.info("asset was not approved");
                    }}
                    onConfirm={() => {
                      handleApproveAsset(data._id);
                    }}
                  >
                    <Tooltip title="approve asset">
                      <IconButton
                        style={{ border: "1px solid #000" }}
                        size="small"
                        disabled={success ? true : false}
                      >
                        <CheckOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Popconfirm>

                  <Popconfirm
                    title="Are you sure you want to delete this asset?"
                    okText="Yes"
                    onConfirm={() => {
                      handleDeleteAsset(data._id);
                    }}
                  >
                    <Tooltip title="delete">
                      <IconButton
                        style={{ border: "1px solid #000" }}
                        size="small"
                      >
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Popconfirm>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        style={{ color: mode === "dark" ? "#ffffff" : "#000000" }}
        component="div"
        count={newAsset.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}
